<template>
<section class="content">
    <div>
        <div class="main_select_wrp_relative staff_select_pop_wrp helpernewwrp">
            <div class="modal fade model_modify_wrp staff_wrp" id="filtertoogle" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div class="modal-dialog" role="document" style="width: 50%">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h2>Filters</h2>
                            <button type="button" class="close clearButton" data-dismiss="modal" v-on:click="clearFilter">Clear All</button>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">
                            <div class="main_select_wrp">
                                <div class="flex selectwca_wrp">
                                    <div class="multiselected">
                                        <label>Role Type</label>
                                        <multiselect track-by="value" v-model="clearFilters.roleType.value" label="name" placeholder="Select RoleType" :options="roleTypes" multiple name="roleType" selectLabel="" deselectLabel="" selectedLabel="" @select="onCheckedrT" @remove="onRemoverT"></multiselect>
                                    </div>
                                    <div class="multiselected">
                                        <label>Status</label>
                                        <multiselect track-by="value" v-model="clearFilters.status.value" label="name" placeholder="Select Status" :options="status" :key="status.length" name="status" selectLabel="" deselectLabel="" selectedLabel="" @select="onSelectStatus" @remove="onRemoveStatus"></multiselect>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div style="position:relative">
            <div class="datedrop_boxs_wrapper">
                <div class="datedrop_boxs_inner datedrop_boxs_inner_survey helperanddriverwrp">
                    <div :class="addButtonClass">
                        <div class="filter_wrpp">
                            <button type="button" class="btn gradientbt" data-toggle="modal" data-target="#filtertoogle">
                                <svg xmlns="http://www.w3.org/2000/svg" xmlns:cc="http://creativecommons.org/ns#" xmlns:dc="http://purl.org/dc/elements/1.1/" xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#">
                                    <g transform="translate(0 -1028.4)">
                                        <path d="m10 11v10l4 3v-13h-4z" fill="#fff" transform="translate(0 1028.4)" />
                                        <path d="m10 11v10l2 1.5v-11.5h-2z" fill="#fff" transform="translate(0 1028.4)" />
                                        <path d="m1 1028.4 9 11h4l9-11z" fill="#fff" />
                                        <path d="m1 1028.4 9 11h2v-11z" fill="#fff" />
                                    </g>
                                </svg>
                                Apply Filter
                    <span :class="{'counter_filter' : count }">{{ count }}</span>
                            </button>
                        </div>
                        <router-link :to="{ name: 'helperAndDriverCreate', params: { _id: '0' } }">
                        <button class=" btn gradientbt">Add Staff</button>
                    </router-link>
                    </div>
                </div>
            </div>
            <div class="box-body">
                <!-- <div :class="addButtonClass">
                    <router-link :to="{ name: 'helperAndDriverCreate', params: { _id: '0' } }">
                        <button class=" btn gradientbt">Add Staff</button>
                    </router-link>
                </div> -->

                <v-server-table ref="helperAndDriverTable" url :limit="5" :columns="columns" :options="options" @loaded="onLoaded">
                    <template slot="beforeBody">
                        <tr v-if="loading" class="VueTables__no-results">
                            <td class="text-center" colspan="6">
                                <pulse-loader></pulse-loader>
                            </td>
                        </tr>
                    </template>
                    <template slot="action" slot-scope="props">
                        <div class="active_wrp">
                            <a class="fa fa-edit" role="button" v-on:click.stop="action(props.row)"></a>
                            <div class="py-2 text-center row">
                                <label class="toggle">
                                    <input class="toggle-checkbox" type="checkbox" :checked="props.row.isActive" @click.prevent="(e) => activatestaffModal(props.row)" />
                                    <span class="slider"></span>
                                    <!-- <span class="labels" data-on="Active" data-off="Deactivate"></span> -->
                                </label>
                            <!-- <a v-if="props.row.roleName == 'Surveyor'" class="fa fa-calendar" v-on:click="calendar(props.row)" style="font-size:25px"></a> -->
                            </div>
                        </div>
                    </template>
                </v-server-table>
            </div>
        </div>
    </div>
</section>
</template>

<script>
import {
    eventBus,
    helperAndDriverService,
    cityService,
} from "../../../services";
import {
    USER_ROLES
} from "../../../config";
import {
    ServerTable,
    Event
} from "vue-tables-2";
import {
    mapState
} from "vuex";

import store from "../../../store";
import swal from "sweetalert2";
import {
    param
} from "change-case";
import {
    Multiselect
} from "vue-multiselect";
import { log } from 'console';

export default {
    name: "helperAndDriver",
    components: {
        Multiselect,
    },
    data() {
        return {
            clearFilters:{
                roleType: "",
                city: "",
                status: "",
            },
            
            checkRole: "",
            params: {},
            roleTypes: [{
                    name: "Driver",
                    value: "Driver"
                },
                {
                    name: "Helper",
                    value: "Helper"
                },
                {
                    name: "Surveyor",
                    value: "Surveyor"
                },
                {
                    name: "Supervisor",
                    value: "Supervisor"
                },
                {
                    name: "Report Manager",
                    value: "Report Manager"
                },
                {
                    name: "Monitoring Manager",
                    value: "Monitoring Manager"
                },
                {
                    name: "City SubAdminmin",
                    value: "City SubAdminmin"
                }
            ],
            status: [{
                    name: "Active",
                    value: true
                },
                {
                    name: "Inactive",
                    value: false
                },
            ],
            count: null,
            count1: 0,
            cityFilterCount: 0,
            roleFilterCount: 0,
            activeInactiveStatus: 0,
            checkedRoleType: [],
            filters: {},
            areas: [],
            loading: null,
            data: {},
            staffInfo: {},
            isActive: null,
            USER_ROLES: USER_ROLES,
            helperAndDriverTable: null,
            columns: ["fullName","mobile", "email", "roleName", "action"],
            options: {
                highlightMatches: true,
                headings: {
                    cityName: "City",
                    fullName: "Staff Name",
                    mobile:"Contact",
                    email: "Staff Email",
                    roleName: "Role Type",
                    action: "Action",
                },
                perPage: 10,
                sortable: ["cityName","fullName","mobile", "email", "roleName"],
                templates: {
                    email(row, query) {
                        if (!query.email) {
                            return "NA";
                        } else {
                            return query.email;
                        }
                    },
                },
                requestFunction: (request) => {
                    this.params.page = request.page;
                    this.params.limit = request.limit;
                    this.params.sortBy = "createdAt";
                    this.params.sortOrder = "des";
                    if (request.orderBy) {
                        if (request.orderBy == "roleName") {
                            this.params.sortBy = "role.name";
                        } else if (request.orderBy == "cityName") {
                            this.params.sortBy = "cityData.cityName";
                        } else if (request.orderBy == "fullName") {
                            this.params.sortBy = "firstName";
                        } else {
                            this.params.sortBy = request.orderBy;
                        }
                        if (request.ascending == 1) {
                            this.params.sortOrder = "asc";
                        } else {
                            this.params.sortOrder = "des";
                        }
                    }
                    if (request.query) {
                        // if(request.query.length < 3) return;
                        this.params.searchString = request.query;
                    } else {
                        this.params.searchString = "";
                    }
                    if(this.count === 0 && this.count1 === 0) {
                        this.count = null;
                        this.count1 = null;
                    }
                    this.loading = true;
                    return this.$userRepository
                        .listOfStaffUsers(this.params)
                        .catch((error) => {
                            console.error("HelperAndDriver.requestFunction-error:", error);
                        });
                },

                responseAdapter: (response) => {
                    this.loading = false;
                    var dataResp = [];
                    let count;
                    response.data.response.forEach((element) => {
                        var userData = element;
                        userData["cityName"] =
                            element.cityData != null ? element.cityData.cityName : null;
                        userData["roleName"] = element.role.name;
                        userData["fullName"] = element.firstName + " " + element.lastName;
                        dataResp.push(userData);
                    });
                    if (dataResp.length === 0) {
                        count = 0;
                    }
                    return {
                        data: dataResp,
                        count: response.data.total || count,
                    };
                },
                customFilters: [{
                    name: "custom_filter",
                    callback: function (row, query) {},
                }, ],
                uniqueKey: "_id",
            },
        };
    },
    computed: {
        addButtonClass() {
            if (this.helperAndDriverTable) {
                return this.helperAndDriverTable.count >
                    this.helperAndDriverTable.limit ||
                    this.helperAndDriverTable.limit > 10 ?
                    "shift-add-left" :
                    "add-item";
            } else {
                return "add-item";
            }
        },
        ...mapState({
            user: (state) => state.auth.user,
        }),
    },
    methods: {
        clearFilter(){  
            this.clearFilters = {
                roleType: "",
           
                status: "",
            };
    
            this.count = null;
            this.count1 = 0;
            this.cityFilterCount = 0;
            this.roleFilterCount = 0;
            this.activeInactiveStatus = 0;
            delete this.params["roleType"];
            delete this.params["isActive"];
            this.$refs.helperAndDriverTable.refresh();
        },
        action(row) {
            this.$router.push({
                name: "helperAndDriverCreate",
                params: {
                    _id: row._id,
                },
                props: row,
            });
        },
        onSelectStatus(option){
            if(this.activeInactiveStatus === 0){
                this.activeInactiveStatus = 1;
                this.count += 1;
                this.count1 += 1;
            }
            if(this.$route.params.roleType === 'driver') {
                const option = {
                    name: 'Acive',
                    value: [{
                        name: 'Active',
                        value: true
                    }]
                };
                this.clearFilters.status = option;                
                this.params["isActive"] = true;
            } else {
            this.clearFilters.status = option;
            this.params["isActive"] = option.value;
            this.$refs.helperAndDriverTable.refresh();
            }
        },
        onRemoveStatus(){
            this.activeInactiveStatus = 0;
            this.count -= 1;
            this.count1 -= 1;
            this.clearFilters.status = "";
            this.params["isActive"] = "";
            this.$refs.helperAndDriverTable.refresh();
        },
        activatestaffModal(row) {
            let confirmtext;
            if (row.isActive === true) {
                confirmtext = "Deactivate";
            } else {
                confirmtext = "Activate";
            }
            swal({
                title: `Are you sure you want to ${confirmtext}?`,
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "#0f6940",
                cancelButtonColor: "#d33",
                confirmButtonText: `Yes, ${confirmtext}`,
            }).then((result) => {
                if (result.value) {
                    this.activateStaff(row);
                } else {
                    swal.close();
                }
            });
        },
        activateStaff(row) {
            let status;
            let confirmtext;
            if (row.isActive === true) {
                confirmtext = "Deactivate";
                status = false;
            } else {
                confirmtext = "Activate";
                status = true;
            }
            this.loading = true;
            let data = {
                status: confirmtext,
                firstName: row.firstName,
                lastName: row.lastName,
                email: row.email,
                licenceNumber: row.licenceNumber,
                idProof: row.idProof,
                dateAdded: row.dateAdded,
                _id: row._id,
            };
            this.staffInfo = {};
            this.data = {};
            this.loading = true;
            this.data["email"] = row.email;
            this.data["cityId"] = row.cityId;
            this.data["firstName"] = row.firstName;
            this.data["lastName"] = row.lastName;
            this.data["permissions"] = row.permissions;
            this.data["role"] = row.role;
            this.data["licenceNumber"] = row.licenceNumber;
            this.data["expiryDate"] = row.expiryDate;
            this.data["licenceFront"] = "";
            this.data["licenceBack"] = "";
            this.data["_id"] = row._id;
            this.data["isActive"] = !row.isActive;
            this.staffInfo["user"] = this.data;
            this.staffInfo["registerType"] = "Register";

            return helperAndDriverService
                .updateHelperAndDriver(this.staffInfo)
                .then((response) => {
                    this.loading = false;
                    row.status = confirmtext;
                    row.isActive = !row.isActive;
                    this.$snotify.success(
                        `The ${row.fullName} has been marked ${confirmtext}.`
                    );
                })
                .catch((error) => {
                    this.loading = false;
                    console.error("TransportPoint.activateTransportPoint-error:", error);
                    this.$snotify.error("Activate user failed", "Error!");
                });
        },
        rowClick(data) {
            this.$router.push({
                name: "helperAndDriverCreate",
                params: {
                    _id: data.row._id,
                },
                props: data.row,
            });
        },
        onLoaded() {
            this.helperAndDriverTable = this.$refs.helperAndDriverTable;
        },
        applyFilter(filter_val) {
            Event.$emit("vue-tables.customFilters::custom_filter", filter_val);
        },

        onChecked(option) {
            // if(this.cityFilterCount === 0){
            //     this.count += 1;
            //     this.cityFilterCount = 1;
            // }
            this.clearFilters.city = option;
            let id = option.value;
            this.checkedRoleType = []
            delete this.params["roleType"];
            this.params.cityId = id;
            this.clearFilters.roleType = ""
            if(this.$refs.helperAndDriverTable.refresh){
                this.$refs.helperAndDriverTable.refresh();
            }
            
        },
        onRemove() {
            this.count = this.count1;
            this.cityFilterCount = 0;
            this.params.cityId = "";
            this.$refs.helperAndDriverTable.refresh();
        },

        onCheckedrT(option) {
            if(this.roleFilterCount === 0){
                this.roleFilterCount = 1;
                this.count += 1;
                this.count1 += 1;
            }
            if(this.$route.params.roleType === 'driver'){
                const option = {
                    name: 'Driver',
                    value: [{
                        name: 'Driver',
                        value: 'driver'
                    }]
                };
                this.clearFilters.roleType = option;
                this.params["roleType"] = ['Driver'];
            } else {
                this.clearFilters.roleType = option;
                let name = option.value;
                this.checkedRoleType.push(name);
                this.roleSelect(this.checkedRoleType);
            }
        },
        onRemoverT(option) {
            let name = option.value;
            this.checkedRoleType = this.checkedRoleType.filter((elemant) => elemant != name );
            this.params["roleType"] = this.checkedRoleType;
            if(this.roleFilterCount === 1 && this.params["roleType"].length === 0){
                this.count -= 1;
                this.count1 -= 1;
                this.roleFilterCount = 0;
            }
            this.$refs.helperAndDriverTable.refresh();
        },

        roleSelect(roleType) {
            this.params["roleType"] = roleType.reduce((accumulator, currentValue) => {
                if (accumulator) {
                    return `${accumulator},${currentValue}`;
                } else {
                    return currentValue;
                }
            }, "");
            this.$refs.helperAndDriverTable.refresh();
        },

        getCityList() {
            this.loading = true;
            let data = [];
            const params = {};
            this.$cityRepository
                .collectionCitysList(params)
                .then((res) => {
                    this.loading = false;
                    res.data.response.forEach((element) => {
                        let val = {};
                        val["name"] = element.cityName.length > 20 ? element.cityName.slice(0, 20) + "..."  :element.cityName;
                        val["value"] = element._id;
                        data.push(val);
                    });
                    this.areas = data.sort((a, b) => a.name.localeCompare(b.name));
                })
                .catch((error) => {
                    this.loading = false;
                    console.error("cities.requestFunction-error:", error);
                    this.$snotify.error("Get cities list failed", "Error!");
                });
        },
        calendar(row) {
            this.$router.push({
                name: "dutyTracking",
                params: {
                    _id: row._id,
                    row: row
                },
                props: row,
            });
        },
    },
    mounted() {
        this.params.cityId = this.$store.state.auth.cityId.value
        eventBus.$on('cityIdChanged', this.onChecked);
        if (this.$store.state.auth.user.role.key === "superAdmin") {
            this.columns.unshift("cityName");
        }
        eventBus.$on("DATA_PUBLISHED", (payload) => {});
        this.checkRole = this.$store.state.auth.user.role.name;
        this.getCityList();
    },
    beforeDestroy() {
        eventBus.$off('cityIdChanged', this.onChecked);
    },
    created() {
        if(this.$route.params.roleType){
            this.onCheckedrT();
            this.onSelectStatus();
        }
        this.clearFilters = {
            ...this.clearFilters,
            city:{
                ...this.clearFilters.city,
                value:this.$route.params.cityIds
            }
        }
            
        if(this.$route.params.cityIds && this.$route.params.cityIds.value){
            this.params.cityId = this.clearFilters.city.value.value;
            // if(this.cityFilterCount === 0){
            //     this.count += 1;
            //     this.cityFilterCount = 1;
            // }
            if(this.$refs.helperAndDriverTable && this.$refs.helperAndDriverTable.refresh){
                this.$refs.helperAndDriverTable.refresh();
            }
           
        }
    }
};
</script>

<style>
.sorting {
    position: absolute;
    left: 319px;
    z-index: 1000;
    width: 200px;
}

.box-body {
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
}

.gradientbt {
    background: #0f6940;
    color: white;
}

* new css */ .toggle {
    --width: 64px;
    --height: calc(var(--width) / 3);

    position: relative;
    display: inline-block;
    width: var(--width);
    height: var(--height);
    box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.3);
    border-radius: var(--height);
    cursor: pointer;
    margin-bottom: 0px;
    position: relative;
    top: 2px;
}

.toggle input {
    display: none;
}

.toggle .slider {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border-radius: var(--height);
    background-color: #ccc;
    transition: all 0.4s ease-in-out;
}

.toggle .slider::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: calc(var(--height));
    height: calc(var(--height));
    border-radius: calc(var(--height) / 2);
    background-color: #fff;
    box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.3);
    transition: all 0.4s ease-in-out;
}

.toggle input:checked+.slider {
    background-color: #0f6940;
}

.toggle input:checked+.slider::before {
    transform: translateX(calc(var(--width) - var(--height)));
}

.toggle .labels {
    position: absolute;
    top: 4px;
    left: 0;
    width: 100%;
    height: 100%;
    font-size: 10px;
    font-family: sans-serif;
    transition: all 0.4s ease-in-out;
}

.toggle .labels::after {
    content: attr(data-off);
    position: absolute;
    right: 5px;
    color: #4d4d4d;
    opacity: 1;
    text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.4);
    transition: all 0.4s ease-in-out;
}

.toggle .labels::before {
    content: attr(data-on);
    position: absolute;
    left: 5px;
    color: #ffffff;
    opacity: 0;
    text-shadow: 1px 1px 2px rgba(255, 255, 255, 0.4);
    transition: all 0.4s ease-in-out;
}

.toggle input:checked~.labels::after {
    opacity: 0;
}

.toggle input:checked~.labels::before {
    opacity: 1;
}

.active_wrp {
    display: flex;
    align-items: center;
}

.active_wrp a {
    flex: 0 0 30%;
    color: #0f6940;
    margin-right: 5px;
}

.multiselected {
    min-width: 145px;
    max-width: 146px;
}

.flex {
    display: flex;
}

.selectwca_wrp .multiselect__tags {
    min-height: 26px;
    display: block;
    padding: 4px 35px 0px 7px;
    border-radius: 5px;
    border: 1px solid #e8e8e8;
    background: #fff;
    display: flex;
    align-items: center;
    margin-right: 10px;
}

.selectwca_wrp .multiselect__select:before {
    top: 50%;
}

.selectwca_wrp .multiselect__tag {
    padding: 4px 15px 4px 10px;
}

.selectwca_wrp .multiselect__tags-wrap {
    background: #fff;
    overflow: hidden;
    overflow-y: auto;
    max-height: 70px;
    position: absolute;
    top: 35px;
    left: 0;
    padding: 10px 10px 0px;
}

.selectwca_wrp .multiselect__tags-wrap::-webkit-scrollbar {
    width: 5px;
}

.selectwca_wrp .multiselect__tags-wrap::-webkit-scrollbar-thumb {
    background: #888;
}

.datedrop_boxs_wrapper {
    position: relative;
    z-index: 2;
}

.datedrop_boxs_inner {
    position: absolute;
    right: 185px;
    top: 5px;
}

.datedrop_boxs_inner_survey.datedrop_boxs_inner_helper {
    right: 85px !important;
}

.datedrop_boxs_inner button {
    background: #0f6940;
    color: #fff;
    border: 0;
    padding: 5px 20px;
    border-radius: 5px;
}

.datedrop_boxs_inner_survey button {
    padding: 6px 20px !important;
    width: max-content;
    margin-right: 10px;
}

.datedrop_boxs_inner_survey {
    top: 10px !important;
}

.shift-addbtn {
    position: absolute;
    right: 200px;
    z-index: 1000;
}

.main_select_wrp_relative .modal-dialog {
    width: 57% !important;
}

.main_select_wrp_relative {
    position: absolute;
    right: 30%;
    top: 25px;
}

.filter_wrpp button svg {
    width: 20px;
    height: 20px;
    margin-right: 10px;
}

.filter_wrpp button {
    display: flex;
    align-items: center;
    margin-right: 5px;
}

.filter_wrpp button:hover {
    background: #0f6940;
    color: #fff;
}

.main_select_wrp_relative+.add-item {
    display: flex;
}

.staff_select_pop_wrp .selectwca_wrp .multiselected {
    min-width: 50.5%;
}

.filter_wrpp_staff {
    position: absolute;
    right: 22%;
    top: 25px;
    z-index: 1;
}

.helpernewwrp .selectwca_wrp .multiselect__tags-wrap{
  width: 92%;
  background: transparent;
}
.helpernewwrp .selectwca_wrp .multiselect__tags{
    min-height: 35px;
}
@media(max-width:767px){
    .main_select_wrp_relative .modal-dialog {
        width: 94% !important;
    }
}
</style>



// WEBPACK FOOTER //
// helperAndDriver.vue?77b4f120